module.exports = __webpack_public_path__ + "static/media/right-arrow.6d15d93a.svg";